module.exports = __webpack_public_path__ + "static/img/d2-1sk.4cf936f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/traditional/home/mobile/role/d2-1sk.png
// module id = q6Bv
// module chunks = 0